import classNames from 'classnames';
import * as React from 'react';
// import { Link } from 'react-router-dom';

import '../../styles/Button.scss';
import { renderSwitch } from '../../utils';
import { defined } from '../../utils/variableEvaluation';
import { Spinner } from '../Spinner';

export enum EButtonType {
  PillLarge = 'Pill Large',
  PillMedium = 'Pill Medium',
  InvertedPillMedium = 'Inverted Pill Medium',
  InvertedPillLarge = 'Inverted Pill Large',
  PillSmall = 'Pill Small',
  FullWidth = 'Full Width',
  FullWidthInverted = 'Full Width Inverted',
  BasicLink = 'Basic Link',
}

enum EButtonActionType {
  InternalLink = 'Internal Link',
  ExternalLink = 'External Link',
  NormalButton = 'Normal Button',
}

interface IProps {
  buttonType?: EButtonType;
  to?: string;
  href?: string;
  isLoading?: boolean;
  notBlank?: boolean;
  id?: string;
  isDisabled?: boolean;
  submit?: boolean;
  className?: string;
  title?: string;
  onClick?: any;
  onHover?: any;
  onLeave?: any;
  children?: any;
  target?: string;
  rel?: string;
  isSvgFill?: boolean;
  isSvgStroke?: boolean;
}

export const Button = (props: IProps) => {
  const {
    isDisabled,
    isLoading,
    buttonType,
    to,
    href,
    id,
    children,
    className,
    onClick,
    onHover,
    onLeave,
    submit,
    notBlank,
    isSvgFill,
    isSvgStroke,
    ...remainingProps
  }: IProps = props;

  const buttonClass = classNames('button', className, {
    'bPill large': buttonType === EButtonType.PillLarge,
    'bPill medium': buttonType === EButtonType.PillMedium,
    'bPill small': buttonType === EButtonType.PillSmall,
    'bPill fullWidth': buttonType === EButtonType.FullWidth,
    'bPill fullWidthInverted': buttonType === EButtonType.FullWidthInverted,
    'invertedPill medium': buttonType === EButtonType.InvertedPillMedium,
    'invertedPill large': buttonType === EButtonType.InvertedPillLarge,
    basicLink: buttonType === EButtonType.BasicLink,
  });

  const action = (): string => {
    if (defined(to)) {
      return EButtonActionType.InternalLink;
    } else if (defined(href)) {
      return EButtonActionType.ExternalLink;
    } else {
      return EButtonActionType.NormalButton;
    }
  };

  return renderSwitch(action(), {
    // [EButtonActionType.InternalLink]: () => (
    //     <Link id={id} key={`Link-${to}`} to={to} className={buttonClass} role="button" {...remainingProps}>
    //         {children}
    //     </Link>
    // ),
    [EButtonActionType.ExternalLink]: () => (
      <a
        id={id}
        key={`a-${href}`}
        href={href}
        className={classNames(buttonClass, {
          disabled: isDisabled,
          'svg-fill': isSvgFill === undefined ? true : isSvgFill, // default to true for back compatibility
          'svg-stroke': isSvgStroke,
        })}
        role='button'
        target={notBlank ? '' : '_blank'}
        rel='noopener noreferrer'
        onMouseOver={onHover}
        onMouseLeave={onLeave}
        {...remainingProps}
      >
        {children}
      </a>
    ),
    [EButtonActionType.NormalButton]: () => (
      <button
        id={id}
        key='button'
        className={classNames(buttonClass, {
          'button-link': buttonType == EButtonType.FullWidthInverted,
          'svg-fill': isSvgFill === undefined ? true : isSvgFill, // default to true for back compatibility
          'svg-stroke': isSvgStroke,
        })}
        disabled={isDisabled}
        onClick={onClick}
        onMouseOver={onHover}
        onMouseLeave={onLeave}
        type={submit ? 'submit' : 'button'}
      >
        {isLoading ? (
          <>
            <Spinner isWhite={true} />
            {children}
          </>
        ) : (
          children
        )}
      </button>
    ),
  });
};
